module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-discount-4e0abe5bfd4156b6fe0d29c30e48a987.webp";